import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { UpdateBookingType } from "../schema/UpdateBookingSchema";
import { ValidationErrorResponse } from "../response/ValidationErrorResponse";
import { UpdateBookingResponse } from "../response/UpdateBookingResponse";

export const useUpdateBooking = () => {
    return useMutation({
        mutationFn: async (values: {
            bookingId: string;
            formData: UpdateBookingType;
        }) => privateApi.put(`/v3/booking/${values.bookingId}`, values.formData),
        onSuccess: async (response) => {
            try {
                const validationResult = UpdateBookingResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid update booking data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update booking', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid booking data format");
            } else {
                console.error('Failed to update booking', error);
                throw error;
            }
        },
    });
};